<template>

  <inventory-calendar-popup :title="title">

    <div class="d-flex justify-space-between">
      <div>
        {{ Temporal.PlainDateTime.from(item.start).toPlainTime().toLocaleString(undefined, {timeStyle: 'short'}) }} –
        {{ Temporal.PlainDateTime.from(item.end).toPlainTime().toLocaleString(undefined, {timeStyle: 'short'}) }}
      </div>
      <div class="text-end">
        {{ item.spacesSold }}/{{ item.spacesTotal }}
      </div>
    </div>

    <table v-if="Object.keys(item.events).length" class="calendar-popup-table mt-4">
      <caption>{{ $t('titles.events') }}</caption>
      <thead>
        <tr>
          <th scope="col">{{ $t('titles.venue') }}</th>
          <th scope="col">{{ $t('titles.event') }}</th>
          <th scope="col" class="text-end">{{ $t('titles.sold') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(event, _) in item.events">
          <td>{{ event.venueName }}</td>
          <td>{{ event.eventName }}</td>
          <td class="text-end">{{ event.spacesSold }}</td>
        </tr>
      </tbody>
    </table>

    <table v-if="Object.keys(item.blackouts).length" class="calendar-popup-table mt-4">
      <caption>{{ $t('titles.blackouts') }}</caption>
      <thead>
        <tr>
          <th scope="col">
            {{ $t('titles.name') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(name, _) in item.blackouts">
          <td>{{ name }}</td>
        </tr>
      </tbody>
    </table>

    <table class="calendar-popup-table mt-4">
      <caption>{{ $t('titles.channel_breakdown') }}</caption>
      <thead>
        <tr>
          <th scope="col">{{ $t('titles.channel') }}</th>
          <th scope="col" class="text-end">{{ $t('titles.sold') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in channelBreakdownRows">
          <td>{{ row.channelTitle }}</td>
          <td class="text-end">{{ row.spacesSold }}</td>
        </tr>
      </tbody>
    </table>

  </inventory-calendar-popup>

</template>

<script setup lang="ts">

import { computed } from 'vue'

// components
import InventoryCalendarPopup from './InventoryCalendarPopup.vue'
import type { DayNormalInventoryCalendarItem } from '../calendarItemTypes'

// models
interface Props {
  item: DayNormalInventoryCalendarItem
}

// misc
import ChannelRegistry from '../../../../../channels/ChannelRegistry'
import { Temporal } from '@js-temporal/polyfill'

const props = defineProps<Props>()

const title = computed<string>(() => {
  return props.item.locationProduct.product.name
})

const channelBreakdownRows = computed(() => {

  return Object.entries(props.item.spacesSoldPerChannel).map(([channel, spacesSold]) => {
    return {
      channelTitle: ChannelRegistry.findTitle(channel),
      spacesSold: spacesSold,
    }
  }).sort((row1, row2) => row1.channelTitle.localeCompare(row2.channelTitle))

})

</script>
